import React from "react";
import { useNavigate } from "react-router-dom";

const SupportLocalCampaign = ({ data }) => {
  const navigate = useNavigate();

  const defaultData = {
    title: "Support Local. Strengthen Communities.",
    subtitle:
      "Every purchase from a neighbourhood business creates opportunities, livelihoods and stronger local economies.",

    impact: [
      {
        icon: "🏪",
        value: "1,00,00,000+",
        label: "Local Businesses",
      },
      {
        icon: "👩",
        value: "50,00,000+",
        label: "Women Entrepreneurs",
      },
      {
        icon: "🎓",
        value: "1,00,000+",
        label: "Youth Organisers",
      },
      {
        icon: "🏘️",
        value: "70,00,000+",
        label: "Neighbourhoods",
      },
    ],

    actions: [
        {
            icon: "🛍️",
            title: "Local Discoveries",
            desc: "Discover and support nearby instant need & businesses.",
            route: "/finditlocal"
        },
        {
            icon: "🏪",
            title: "Become Merchant",
            desc: "Bring your business online with Think5Whys ➤ PurpleDoor.",
            route: "/purpledoor"
        },
        {
            icon: "👥",
            title: "Create Impact",
            desc: "Become a neighbourhood phygytal exhibition organiser.",
            route: "/nabora/organiser"
        },
        {
            icon: "💜",
            title: "FoundHer",
            desc: "Support young women entrepreneurs and digital angels.",
            route: "/foundher"
        },
        {
            icon: "🛒",
            title: "HerKart",
            desc: "Discover women-led marketplace, private stores, innovations, brands, services and products.",
            route: "/herkart"
        },
        {
          icon: "📺",
          title: "FiLTV (FindItLocal TV)",
          desc: "Watch local brands, offers, and stories form your neighbourhood on Think5Whys MobileTV.",
          route: "/filtv"
        },
        {
            icon: "🛕",
            title: "VocalForLocal",
            desc: "Promote local (Area/Neighbourhood, City/District, PINCode/PostalCode, State based products, creators and businesses.",
            route: "/vocalforlocal"
        },
    ]
  };

  const content = data || defaultData;

  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <section className="py-10 px-6 bg-gradient-to-br from-violet-950 via-purple-950 to-slate-950">
        <div className="max-w-5xl mx-auto text-center">
          <div className="uppercase tracking-[4px] text-yellow-300 text-sm mb-4">
            ❤️ SUPPORT LOCAL CAMPAIGN
          </div>

          <h1 className="text-2xl lg:text-4xl font-bold mb-4">
            {content.title}
          </h1>

          <p className="text-slate-300 text-base lg:text-xl max-w-3xl mx-auto">
            {content.subtitle}
          </p>
        </div>
      </section>

      <section className="py-8 px-6">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-center text-xl lg:text-2xl font-bold text-cyan-200 mb-6">
            Our Community Impact Vision
          </h2>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {content.impact.map((item, index) => (
              <div
                key={index}
                className="bg-slate-900/80 rounded-3xl p-5 border border-white/10 text-center"
              >
                <div className="text-4xl mb-3">{item.icon}</div>

                <div className="text-xl lg:text-2xl font-bold text-white">
                  {item.value}
                </div>

                <div className="text-slate-300 text-sm">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-8 px-6 bg-gradient-to-br from-slate-900 to-violet-950">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {content.actions.map((item, index) => (
              <div
                key={index}
                className="bg-white/5 rounded-3xl p-6 border border-white/10 hover:border-purple-400/50 transition-all text-center"
              >
                <div className="text-5xl mb-4">{item.icon}</div>

                <h3 className="text-lg font-bold mb-2 text-cyan-200">{item.title}</h3>

                <p className="text-slate-300 text-sm mb-5">{item.desc}</p>

                <button
                  onClick={() => navigate(item.route)}
                  className="w-full px-4 py-2 rounded-xl bg-gradient-to-r from-fuchsia-500 to-violet-600 font-semibold hover:scale-105 transition-all"
                >
                  Explore →
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-10 px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="text-5xl mb-4">💜</div>

          <h2 className="text-xl lg:text-3xl font-bold mb-3 text-cyan-200">
            Together We Build Stronger Neighbourhoods
          </h2>

          <p className="text-slate-300 mb-6">
            Every merchant supported, every local purchase made, and every
            community connected creates a bigger impact.
          </p>

          <button
            onClick={() => navigate("/finditlocal")}
            className="px-6 py-3 rounded-xl border border-white/30 hover:bg-white/10 transition-all"
          >
            📍 Discover Local Businesses
          </button>
        </div>
      </section>
    </div>
  );
};

export default SupportLocalCampaign;
